<template>
  <v-expansion-panel-header
    v-if="menu"
    v-slot="{ open }"
    expand-icon=""
    style="padding: 0;"
    :style="{ 
      'border-radius': `0 0 0 0`,
      'cursor': isSimulation && !isSecundary ? 'move !important' : 'pointer !important',
      'font-family': isSecundary ? FontSecundary : Font,
      'font-size': isSecundary ? `${FontSizeSecundary}px` : `${FontSize}px`,
      'font-weight': menu.ID === activeMenuID ? '900' : '400',
      'background-color': menu.BGColor ? menu.BGColor : isSecundary ? BGColorSecundary : BGColor, 
      'color': menu.TextColor ? menu.TextColor : isSecundary ? ColorSecundary : Color, 
      'background-image': ((isSecundary && withGradientSubmenu) || (!isSecundary && withGradient)) ? 'linear-gradient(to top, rgba(128, 128, 128, 0.0), rgba(0, 0, 0, 0.2))' : '',
      'border-bottom': withLine ? `0.5px solid ${getColor()}` : '',
      'border-top': withLine ? `0.5px solid ${getColor()}` : ''
    }"
    @click="handleExpandMenu(menu.ID)"
    >
    <!-- <v-expansion-panel-header
    v-if="menu"
    v-slot="{ open }"
    expand-icon=""
    style="padding: 0;"
    :style="{ 
      'min-height': isSecundary ? '50px !important' : '65px !important',
      'border-radius': `0 0 0 0`,
      'cursor': isSimulation && !isSecundary ? 'move !important' : 'pointer !important',
      'font-family': isSecundary ? FontSecundary : Font,
      'font-size': isSecundary ? `${FontSizeSecundary}px` : `${FontSize}px`,
      'background-color': isSecundary ? BGColorSecundary : BGColor, 
      'color': isSecundary ? ColorSecundary : Color, 
      'background-image': withGradient ? 'linear-gradient(to top, rgba(128, 128, 128, 0.0), rgba(0, 0, 0, 0.2))' : '',
      'border-bottom': withLine ? `0.5px solid ${getColor()}` : '',
      'border-top': withLine ? `0.5px solid ${getColor()}` : ''
    }"
    @click="onExpandMenu(menu.ID)"
  > -->
    <v-layout
      wrap
      align-center
      justify-center
      style="position: absolute; width: 100%;"
    >
      <v-flex xs12
        style="margin: 10px;"
        :style="{ 'margin': isSecundary ? '10px 0 10px 0' : '0' }"
        :ref="`exp_${data.ID}`"
      >
        <div
          v-if="menu.isNew || isSettings || (menu.IsActive && (!menu.Availability || !menu.Availability.status || (menu.Availability.status.date && menu.Availability.status.time)))"
          class="text-center"
          style="text-decoration: normal !important;"
        >
        <!-- <div
          v-if="menu.IsActive"
          class="text-center"
          style="text-decoration: normal !important;"
        > -->
          <v-icon v-if="isSimulation && authType !== 'none' && menu.Private">mdi-cancel</v-icon>
          {{ isSecundary 
              ? (TextFormatSecundary === 1 ? name.toUpperCase() : TextFormatSecundary === 2 ? name.toLowerCase() : name) 
              : (TextFormat === 1 ? name.toUpperCase() : TextFormat === 2 ? name.toLowerCase() : name)
              }}
        </div>
        <div
          v-else
          class="text-center"
        >
          <strike>{{ name }}</strike>
        </div>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="isSimulation && isMenu"
      wrap
      align-center
      justify-center
      style="position: absolute; width: 100%;"
    >
      <v-flex
        xs4
      >
        <!-- <sort-main-menu />{{menu.ORD}} -->
        <v-icon
          v-if="!isSecundary"
          v-show="!loadingContents"
          style="margin-left: 20px;"
          :style="{ 'font-size': isSecundary ? '14px !important' : '18px !important' }"
          dark
        >
          mdi-cursor-move
        </v-icon>
      </v-flex>
      <v-flex xs3 />
      <v-flex xs5>
        <v-tooltip right v-if="!menu.IsContentFromAnotherWebApp"> 
          <template v-slot:activator="{ on }">
            <v-layout align-right wrap  v-on="!isMenu || menu.isNew ? on : null">
              <!-- <v-flex xs3>
                <v-btn class="mnuEdit" fab 
                  v-if="isSimulation && menu.Common === 0"
                  :dark="isMenu && !menu.isNew"
                  small
                  :color="menu.HideMobile ? 'red' : isSecundary ? `#${!editTMP || menu.ID !== editTMP.ID ? '000000' : '7CFC00' }4D` : `#${!editTMP || menu.ID !== editTMP.ID ? '000000' : '7CFC00' }33`"
                  @click.stop="hanldeHideMenuMobile(menu)"
                  :disabled="!isMenu || menu.isNew || (menu.Common !== 0)"
                >
                  <v-icon dark>{{ isSimulation && menu.Common !== 0 ? 'mdi-lock' : !menu.HideMobile ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                </v-btn>
              </v-flex> -->
              <v-flex xs3>
                <desktop-menu 
                  v-if="isEditDesktopMode && isSimulation && menu.Common === 0 && isMenu && !menu.isNew"
                  v-show="!loadingContents"
                  :menu="menu"
                  :color="isSecundary ? `#${!editTMP || menu.ID !== editTMP.ID ? '000000' : '7CFC00' }4D` : `#${!editTMP || menu.ID !== editTMP.ID ? '000000' : '7CFC00' }33`"
                />
              <!-- <desktop-menu 
                v-if="isEditDesktopMode && isSimulation && menu.Common === 0 && isMenu && !menu.isNew && !menu.IsMenuWithSubmenu"
                :menu="menu"
                :color="isSecundary ? `#${!editTMP || menu.ID !== editTMP.ID ? '000000' : '7CFC00' }4D` : `#${!editTMP || menu.ID !== editTMP.ID ? '000000' : '7CFC00' }33`"
              /> -->
              </v-flex>
              <v-flex xs3>
                <v-btn class="mnuEdit" fab 
                  v-if="isCloneMenu && isSimulation && menu.Common === 0"
                  :dark="isMenu && !menu.isNew"
                  small
                  :color="isSecundary ? `#${!editTMP || menu.ID !== editTMP.ID ? '000000' : '7CFC00' }4D` : `#${!editTMP || menu.ID !== editTMP.ID ? '000000' : '7CFC00' }33`"
                  @click.stop="hanldeClone(menu)"
                  :disabled="loadingContents || !isMenu || menu.isNew || (menu.Common !== 0)"
                >
                  <v-icon dark>{{ isSimulation && menu.Common !== 0 ? 'mdi-lock' : 'mdi-content-copy' }}</v-icon>
                </v-btn>

              </v-flex>
              <v-flex xs3>
                <v-btn class="mnuEdit" fab 
                  v-if="isSimulation && menu.Common === 0"
                  :dark="isMenu && !menu.isNew"
                  small
                  :color="menu.HideMobile ? 'red' : isSecundary ? `#${!editTMP || menu.ID !== editTMP.ID ? '000000' : '7CFC00' }4D` : `#${!editTMP || menu.ID !== editTMP.ID ? '000000' : '7CFC00' }33`"
                  @click.stop="hanldeHideMenu(menu)"
                  :disabled="loadingContents || !isMenu || menu.isNew || (menu.Common !== 0)"
                >
                  <v-icon dark>{{ isSimulation && menu.Common !== 0 ? 'mdi-lock' : !menu.HideMobile ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs3>
              <!-- modificamos el color del boton en base a si es seleccionado o es secundario -->
              <v-btn class="mnuEdit" fab 
                :dark="isMenu && !menu.isNew"
                small
                :color="isSecundary ? `#${!editTMP || menu.ID !== editTMP.ID ? '000000' : '7CFC00' }4D` : `#${!editTMP || menu.ID !== editTMP.ID ? '000000' : '7CFC00' }33`"
                @click.stop="handleEdit(menu)"
                :disabled="loadingContents || !isMenu || menu.isNew || (menu.Common !== 0)"
              >
                <v-icon dark>{{ isSimulation && menu.Common !== 0 ? 'mdi-lock' : 'mdi-pencil' }}</v-icon>
              </v-btn>

              </v-flex>
            </v-layout>
          </template>
          <span>{{ $t('menus.info.saveBeforeEdit') }}</span>
        </v-tooltip>
      </v-flex>
    </v-layout>    
  </v-expansion-panel-header>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import constants from '@/constants'
  import utils from '@/services/utils'
  import api from '@/services/api'
  import SortMainMenu from './SortMainMenu'
  import DesktopMenu from '@/components/desktopMenu/Index'
  export default {
    components: {
      SortMainMenu,
      DesktopMenu
    },
    props: {
      data: {
        type: Object,
        required: true
      },
      isSecundary: {
        type: Boolean,
        required: false,
        default: false
      },
      onEdit: {
        type: Function,
        required: false,
        default: null
      },
      onExpandMenu: {
        type: Function,
        required: false,
        default: null
      }
    },
    data: () => ({
      menu: null,
      statusColor: '#000000',
      isCloneMenu: false,
      isEditDesktopMode: false
    }),
    computed: {
      ...mapState('app',['loadingContents', 'activeMenuID', 'withLine', 'withGradient', 'withGradientSubmenu', 'locale','editTMP', 'BGColor', 'Color', 'FontSecundary', 'FontSizeSecundary','Font', 'FontSize', 'BGColorSecundary', 'ColorSecundary', 'GlobalFont','TextFormat', 'TextFormatSecundary']),
      contentCountLimit () {
        return this.$store.state.app.contentCountLimit
      },
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isCommonMenus () {
        return this.$route.path.split('/')[1] === 'common-menus' ? true : false
      },
      isSettings () {
        return this.$route.path.split('/')[1] === 'settings' ? true : false
      },
      borderRadius () {
        return this.isSimulation ? constants.borderRadius : null
      },
      isMenu () {
        return constants.menusRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      name () {
        let name = utils.getTranslation (this.menu.Name, this.locale)
        if (this.isCommonMenus && this.menu.Alias && this.menu.Alias.length > 0) name = name.concat(` (${this.menu.Alias})`)
        return name
      },
      authType () {
        return this.$store.state.app.authType
      }
      
    },
    watch: {
      data: {
        handler: function (newValue) {
          this.menu = newValue
          this.statusColor = this.menu.ID === 1 || 1 === 1 ? '#000000' : '#7CFC00' 
        },
        deep: true
      },
      'data.IsActive': {
        handler: function (newValue) {
          // this.textDecoration = !newValue ? 'line-through' : 'normal'
        },
        deep: true
      },
    },
    mounted () {
      if(this.isSimulation) this.getPermission()
      this.menu = this.data
      this.statusColor = this.menu.ID === 1 || 1 === 1 ? '#000000' : '#7CFC00'
    },
    methods: {
      getPermission () {
        if (this.userID !== 'new') {
          api.getItem('users', true, utils.getUserID()).then(response => {
            this.isCloneMenu = response.Permission.indexOf(4) >= 0
            this.isEditDesktopMode = response.Permission.indexOf(6) >= 0
          })
        }
      },
      getColor () {
        if (this.isSecundary) {
          if (this.ColorSecundary && this.ColorSecundary.length >= 7) {
            return this.ColorSecundary.substring(0, 7).concat('4d')
          }
          return this.ColorSecundary
        } else {
          if (this.Color && this.Color.length >= 7) {
            return this.Color.substring(0, 7).concat('4d')
          }
          return this.Color
        }
      },
      handleSetStats (menu) {
        // añadimos los registros de accesos públicos
        api.setStats('stats', menu)
          .then(response => {
          })
          .catch(error => {
            console.log('error', error)
          })
      },
      handleExpandMenu(id) {
        let isDomain = false
        // alert('id')
        if (this.menu.WebAppAsLink) {
          this.handleSetStats(this.menu)
          if (!this.isSimulation) {
            let url = ''
            if (this.menu.WebAppAsContentDomain.indexOf('.') > 0) url = this.menu.WebAppAsContentDomain
            else {
              isDomain = true
              url = `${window.location.protocol}//${this.menu.WebAppAsContentDomain}.${process.env.VUE_APP_API_URL}`
              url += '#/?back='+utils.getDomain()
              if (this.locale !== 'es') url += '&locale=' + this.locale
            }
            url = url.replace('@#@', '?')
            if (isDomain) {
              const dfileResp = this.$session.get('dfilesResponse')
              url = `${url}${dfileResp ? '&dfileResp='+dfileResp : ''}`
            }
            // ini showroom
            const actualUrl = window.location.href
            if (actualUrl.indexOf('?') < 0) url += '?'
            if (actualUrl.indexOf('fm=true') > 0) url += '&fm=true'
            if (actualUrl.indexOf('fl=true') > 0) url += '&fl=true'
            // end showroom
            window.location.href = url
          } 
        } else {
          this.$store.state.app.activeMenuID = this.$store.state.app.activeMenuID !== id ? id : null
          this.onExpandMenu(id)        
        }
      },
      hanldeHideMenu(menu) {
        const body = { hide: !menu.HideMobile}
        api.updateItem('menus', menu.ID.concat('/hide'), body)
        .then(response => {
          menu.HideMobile = !menu.HideMobile
        })
        .catch(error => {
          console.log('error', error)
        })
      },
      hanldeHideMenuMobile(menu) {
        const body = { hide: !menu.HideMobile}
        api.updateItem('menus', menu.ID.concat('/hide-mobile'), body)
        .then(response => {
          menu.HideMobile = !menu.HideMobile
        })
        .catch(error => {
          console.log('error', error)
        })
      },
      async hanldeClone(menu) {
        try {
          const contentCount = await new Promise((resolve, reject) => api.getItem('menus', true, `${menu.ID}/content-count`)
            .then(response => {
              resolve(response ? response.Count : null)
            })
            .catch(error => {
              reject(error)
            }))
          if (contentCount === null) {
            alert('Error')
            return
          }
          if (contentCount > (this.contentCountLimit + 10)) {
            alert(`Límite de contenido superado para el menú, contacte con soporte [${contentCount} de ${this.contentCountLimit + 10}]`)
            return
          }
          const aux = this.$store.state.app.menus
           const max = aux.length > 0 ? aux.reduce(function(prev, current) {
              return (prev.ORD > current.ORD) ? prev : current
            }).ORD : 0
          const body= {
            ORD: max + 1,
            IsMenuWithSubmenu: menu.IsMenuWithSubmenu
          }
          // console.log(body)
          api.updateItem('menus', menu.ID.concat('/clone'), body)
            .then(response => {
              const auxID = this.isCommonMenus ? '0000' : this.enterpriseID
              if (auxID) {
                api.getAll(`menus`, false, null, null, null, auxID).then(responseMenus => {
                  responseMenus = responseMenus.map (item => {
                    if (item.Menus) {
                      item.Menus = item.Menus.map (submenu => {
                        submenu.Availability = utils.checkAvailabilityStatus(submenu.Availability)
                        return submenu
                      })
                    }
                    item.Availability = utils.checkAvailabilityStatus(item.Availability)
                    return item
                  })
                  this.$store.state.app.menus = responseMenus
                })
              }
            })
            .catch(error => {
              console.log('error', error)
            })
        } catch (error) {
          console.log(error)
        }
      },
      async handleEdit (v) {
        try {
          if (this.editTMP) {
            alert('Antes de editar debe cancelar o guardar el menú anterior')
            return
          }
          const contentCount = await new Promise((resolve, reject) => api.getItem('menus', true, `${v.ID}/content-count`)
            .then(response => {
              resolve(response ? response.Count : null)
            })
            .catch(error => {
              reject(error)
            }))
          if (contentCount === null) {
            alert('Error')
            return
          }
          if (contentCount > (this.contentCountLimit + 10)) {
            alert(`Límite de contenido superado para el menú, contacte con soporte [${contentCount} de ${this.contentCountLimit + 10}]`)
            return
          }
          this.onEdit(v)
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>
<style scoped>
  .v-content {
    /* background-color: blue; */
  }
  .v-btn--fab.v-size--small {
    width: 30px !important;
    height: 30px !important;
  }
  .v-btn--fab.v-size--small .v-icon {
    font-size: 18px !important;
  }
  .mnuEdit {
    margin-right: 10px;
  }
</style>
